/**
 * One entry per lang/<code>/frontend.json.
 *
 * CAUTION: those files are gitignored — only 41 of them predate the ignore rule and are still
 * tracked; the rest appear when `php artisan i18n:compile-from-central` runs. webpack tolerated
 * that: a locale it did not find simply wasn't in the context, and the page fell back to English.
 * A static map cannot — an entry pointing at a file the build box has not compiled is a hard
 * build error. So this map must be regenerated after the compile step, on the box that builds.
 *
 * GENERATED FILE — do not edit by hand. It replaces a dynamic import whose path was built at
 * runtime, which webpack resolved through require.context and Rolldown cannot resolve at all.
 * Read by resources/js/base/i18n.js. Regenerate after adding or removing a file:
 *
 *     node scripts/generate-import-maps.mjs
 *
 * CI runs the same command with --check. Every value stays a thunk, so the modules are still
 * fetched on demand and still get a chunk each — only the discovery moved to build time.
 */

// Null prototype so an unlisted key reads as undefined instead of resolving to Object.prototype
// ('constructor', 'toString', …) and handing the caller something that is not a loader. webpack's
// context guarded its own map with hasOwnProperty for the same reason.
export const translations = Object.assign(Object.create(null), {
    'af': () => import('../../../lang/af/frontend.json'),
    'am': () => import('../../../lang/am/frontend.json'),
    'ar': () => import('../../../lang/ar/frontend.json'),
    'az': () => import('../../../lang/az/frontend.json'),
    'be': () => import('../../../lang/be/frontend.json'),
    'bg': () => import('../../../lang/bg/frontend.json'),
    'bn': () => import('../../../lang/bn/frontend.json'),
    'bs': () => import('../../../lang/bs/frontend.json'),
    'ca': () => import('../../../lang/ca/frontend.json'),
    'cs': () => import('../../../lang/cs/frontend.json'),
    'cy': () => import('../../../lang/cy/frontend.json'),
    'da': () => import('../../../lang/da/frontend.json'),
    'de': () => import('../../../lang/de/frontend.json'),
    'el': () => import('../../../lang/el/frontend.json'),
    'en': () => import('../../../lang/en/frontend.json'),
    'es': () => import('../../../lang/es/frontend.json'),
    'es-PE': () => import('../../../lang/es-PE/frontend.json'),
    'et': () => import('../../../lang/et/frontend.json'),
    'eu': () => import('../../../lang/eu/frontend.json'),
    'fa': () => import('../../../lang/fa/frontend.json'),
    'fi': () => import('../../../lang/fi/frontend.json'),
    'fil': () => import('../../../lang/fil/frontend.json'),
    'fr': () => import('../../../lang/fr/frontend.json'),
    'fr-HT': () => import('../../../lang/fr-HT/frontend.json'),
    'ga': () => import('../../../lang/ga/frontend.json'),
    'ge': () => import('../../../lang/ge/frontend.json'),
    'gl': () => import('../../../lang/gl/frontend.json'),
    'gu': () => import('../../../lang/gu/frontend.json'),
    'he': () => import('../../../lang/he/frontend.json'),
    'hi': () => import('../../../lang/hi/frontend.json'),
    'hr': () => import('../../../lang/hr/frontend.json'),
    'ht': () => import('../../../lang/ht/frontend.json'),
    'hu': () => import('../../../lang/hu/frontend.json'),
    'hy': () => import('../../../lang/hy/frontend.json'),
    'id': () => import('../../../lang/id/frontend.json'),
    'is': () => import('../../../lang/is/frontend.json'),
    'it': () => import('../../../lang/it/frontend.json'),
    'ja': () => import('../../../lang/ja/frontend.json'),
    'jv': () => import('../../../lang/jv/frontend.json'),
    'ka': () => import('../../../lang/ka/frontend.json'),
    'kk': () => import('../../../lang/kk/frontend.json'),
    'km': () => import('../../../lang/km/frontend.json'),
    'kn': () => import('../../../lang/kn/frontend.json'),
    'ko': () => import('../../../lang/ko/frontend.json'),
    'ky': () => import('../../../lang/ky/frontend.json'),
    'la': () => import('../../../lang/la/frontend.json'),
    'lb': () => import('../../../lang/lb/frontend.json'),
    'lt': () => import('../../../lang/lt/frontend.json'),
    'lv': () => import('../../../lang/lv/frontend.json'),
    'mk': () => import('../../../lang/mk/frontend.json'),
    'ml': () => import('../../../lang/ml/frontend.json'),
    'mn': () => import('../../../lang/mn/frontend.json'),
    'mr': () => import('../../../lang/mr/frontend.json'),
    'ms': () => import('../../../lang/ms/frontend.json'),
    'mt': () => import('../../../lang/mt/frontend.json'),
    'my': () => import('../../../lang/my/frontend.json'),
    'ne': () => import('../../../lang/ne/frontend.json'),
    'nl': () => import('../../../lang/nl/frontend.json'),
    'no': () => import('../../../lang/no/frontend.json'),
    'np': () => import('../../../lang/np/frontend.json'),
    'pa': () => import('../../../lang/pa/frontend.json'),
    'pl': () => import('../../../lang/pl/frontend.json'),
    'ps': () => import('../../../lang/ps/frontend.json'),
    'pt': () => import('../../../lang/pt/frontend.json'),
    'pt-BR': () => import('../../../lang/pt-BR/frontend.json'),
    'pt-MZ': () => import('../../../lang/pt-MZ/frontend.json'),
    'ro': () => import('../../../lang/ro/frontend.json'),
    'ru': () => import('../../../lang/ru/frontend.json'),
    'si': () => import('../../../lang/si/frontend.json'),
    'sk': () => import('../../../lang/sk/frontend.json'),
    'sl': () => import('../../../lang/sl/frontend.json'),
    'sq': () => import('../../../lang/sq/frontend.json'),
    'sr': () => import('../../../lang/sr/frontend.json'),
    'su': () => import('../../../lang/su/frontend.json'),
    'sv': () => import('../../../lang/sv/frontend.json'),
    'sw': () => import('../../../lang/sw/frontend.json'),
    'ta': () => import('../../../lang/ta/frontend.json'),
    'te': () => import('../../../lang/te/frontend.json'),
    'th': () => import('../../../lang/th/frontend.json'),
    'tk': () => import('../../../lang/tk/frontend.json'),
    'tr': () => import('../../../lang/tr/frontend.json'),
    'uk': () => import('../../../lang/uk/frontend.json'),
    'ur': () => import('../../../lang/ur/frontend.json'),
    'uz': () => import('../../../lang/uz/frontend.json'),
    'vi': () => import('../../../lang/vi/frontend.json'),
    'xh': () => import('../../../lang/xh/frontend.json'),
    'yi': () => import('../../../lang/yi/frontend.json'),
    'yo': () => import('../../../lang/yo/frontend.json'),
    'zh': () => import('../../../lang/zh/frontend.json'),
    'zh-TW': () => import('../../../lang/zh-TW/frontend.json'),
    'zu': () => import('../../../lang/zu/frontend.json'),
});

export default translations;
